import React from 'react'
import { connect } from 'react-redux'
import { getMarkerSize } from './'
import Marker from '../Marker'
import Label from '../Marker/Label'
import CompanyMarker from '../Marker/CompanyMarker'
import {
  companiesByActiveModeSelector,
  getSelectedTopicID,
  activeSelector,
} from '../../redux/selector'
import { showCompanyProfile } from '../../redux/modules/companies'
import { updateViewport } from '../../redux/modules/map'

const labelVisibilityZoom = 15

/**
 * Layer component that places companies on the map
 */
const MarkerLayer = ({
  filteredCompanies,
  selectedTopicID,
  viewport,
  active,
  handleMarkerClick,
}) => {
  // TODO: (3) Only render visible marker
  return filteredCompanies.map(company => {
    const {
      id,
      matchesTopic,
      currentAddress: {
        position: { lat, lng },
      },
      employees,
      branch,
    } = company

    const size = getMarkerSize(employees)
    const noTopicOrMatches = !selectedTopicID || matchesTopic
    const showLabel = noTopicOrMatches && viewport.zoom > labelVisibilityZoom
    const clickHandler = () => {
      handleMarkerClick({ id, lat, lng })
    }

    // TODO: (3) Combine marker and label into one element to decrease number of transformations
    // FEATURE: (2) Use Voronoi map to improve targeting
    return (
      <React.Fragment key={`marker-${id}`}>
        <Marker
          latitude={lat}
          longitude={lng}
          size={size}
          style={{ zIndex: noTopicOrMatches ? 2 : 1 }}
        >
          <CompanyMarker
            size={size}
            branch={branch}
            colorize={noTopicOrMatches}
            dim={!active}
            onMarkerClick={clickHandler}
          />
        </Marker>
        {showLabel && (
          <Marker
            latitude={lat}
            longitude={lng}
            offsetLeft={size / 2 + 16}
            style={{ zIndex: noTopicOrMatches ? 4 : 3 }}
          >
            {/* FEATURE: (1) Prevent overlap with forces */}
            <Label size={size} onClick={clickHandler}>
              {company.name}
            </Label>
          </Marker>
        )}
      </React.Fragment>
    )
  })
}

const mapStateToProps = (state, { viewport }) => ({
  filteredCompanies: companiesByActiveModeSelector(state),
  selectedTopicID: getSelectedTopicID(state),
  viewport,
  active: activeSelector(state),
})

const mapDispatchToProps = dispatch => ({
  handleMarkerClick: ({ id, lat, lng }) => {
    // TODO: (3) Only dispatch one action and use cross slice reducer?
    dispatch(showCompanyProfile(id))
    dispatch(
      updateViewport({
        // TODO: (1) Pass offset and combine with PopupLayer function, move downwards
        viewport: { latitude: lat, longitude: lng },
        transition: true,
      })
    )
  },
})

MarkerLayer.defaultProps = {
  companies: [],
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarkerLayer)
